import { render, staticRenderFns } from "./SignalIndicatorSMA.vue?vue&type=template&id=6996e457&scoped=true&"
import script from "./SignalIndicatorSMA.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignalIndicatorSMA.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6996e457",
  null
  
)

export default component.exports